<script lang="ts">
    import {
        S3Client,
        AbortMultipartUploadCommand,
        ListBucketsCommand,
        ListObjectsCommand,
        UploadPartCommand,
        PutObjectCommand,
    } from "@aws-sdk/client-s3";
    import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
    import { onMount } from "svelte";
    import { useNavigate } from "svelte-navigator";
    import { ContentListEntry } from "../../../../../admin-service-typescript-client";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { contentStore } from "../../../../store/contents";
    import { user } from "../../../../store/stores";
    import ContentCard from "./Components/ContentCard.svelte";

    const navigate = useNavigate();
    let newContentModalOpen = false;
    let newContentUrl = "";
    let newContentName = "";
    let graphLabels: string[] = [];
    let iconAsc = "↑";
    let iconDesc = "↓";
    let sortBy = "id";
    let sortOrder = 1;
    let rows = [];
    let loading = true;
    let searchObject: { [key: string]: any } = { creativeId: "" };
    let contentArray: ContentListEntry[] = [];
    let files;
    let client: S3Client;
    let uploading = false;
    let message = "";

    const createNewContent = async () => {
        if (!newContentUrl || !newContentName) {
            alert("Beide Felder müssen ausgefüllt sein.");
            return;
        }
        newContentModalOpen = false;
        await ApiClient.getInstance($user)
            .contentClient.createContent({
                contentRequest: {
                    url: newContentUrl,
                    active: true,
                    name: newContentName,
                    // tags: [{ id: "name", values: [newContentName] }],
                },
            })
            .then(console.log);
        getCreatives();
    };

    const uploadFile = async () => {
        uploading = true;
        if (!files.length) {
            return alert("Please choose a file to upload first.");
        }
        var file = files[0];
        var fileName = file.name;

        var photoKey = fileName;
        const uploadParams = {
            Bucket: "dev-bucket-whizad",
            Key: photoKey,
            Body: file,
        };

        // Use S3 ManagedUpload class as it supports multipart uploads
        await client
            .send(new PutObjectCommand(uploadParams))
            .then((res) => {
                uploading = false;
                message = "Datei erfolgreich gespeichert";
                newContentUrl = `https://dev-bucket-whizad.s3.eu-central-1.amazonaws.com/${fileName}`;
            })
            .catch((err) => {
                uploading = false;
                message = err;
            });
        // var promise = upload.promise();

        // promise.then(
        //     function (data) {
        //         alert("Successfully uploaded photo.");
        //         viewAlbum(albumName);
        //     },
        //     function (err) {
        //         return alert(
        //             "There was an error uploading your photo: ",
        //             err.message
        //         );
        //     }
        // );
    };

    const getCreatives = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .contentClient.listContents({ size: 100 })
                .then((content) =>
                    contentStore.update((contentStore) => {
                        return {
                            ...contentStore,
                            contents: content,
                        };
                    })
                );
        });
    };

    onMount(() => {
        getCreatives();
        client = new S3Client({
            region: "eu-central-1",

            credentials: fromCognitoIdentityPool({
                clientConfig: { region: "eu-central-1" }, // Configure the underlying CognitoIdentityClient.
                identityPoolId:
                    "eu-central-1:2aaaf671-27fb-43df-9f0c-7584249d5f23",
            }),
        });
    });
</script>

<div class="columns is-multiline">
    <div class="column is-12">
        <div class="card sticky">
            <div class="card-content">
                <div class="content">
                    <div class="columns is-vcentered is-multiline">
                        <div class="column is-2">
                            <p
                                class="is-5 greenish-plus"
                                on:click={() => (newContentModalOpen = true)}
                            >
                                +
                            </p>
                        </div>
                        <div class="column is-3 ">
                            <p class="is-5 greenish">Content</p>
                        </div>
                        <div class="column is-3 ">
                            <p class="greenish is-5">Status</p>
                        </div>
                        <div class="column is-3">
                            <p class="greenish is-5">Video</p>
                        </div>
                        {#if $contentStore.contents && $contentStore.contents.entries}
                            {#each $contentStore.contents.entries as campaign}
                                <ContentCard contentEntry={campaign} />
                            {/each}
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
{#if newContentModalOpen}
    <div class="modal is-active">
        <div
            class="modal-background"
            on:click={() => (newContentModalOpen = false)}
        />
        <div class="modal-content">
            <div class="box">
                <div class="field">
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label class="label">Name</label>
                    <div class="control">
                        <input
                            class="input"
                            type="text"
                            placeholder="Bezeichnung"
                            bind:value={newContentName}
                        />
                    </div>
                </div>
                <div class="field">
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label class="label">URL</label>
                    <div class="control">
                        <input
                            class="input"
                            type="text"
                            placeholder="Video URL"
                            bind:value={newContentUrl}
                        />
                    </div>
                </div>
                <div class="field">
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label class="label">Upload</label>
                    <div class="control">
                        <div class="columns">
                            <div class="column is-10">
                                <input
                                    class="input"
                                    type="file"
                                    placeholder="Video URL"
                                    bind:files
                                />
                            </div>
                            <div class="column is-2">
                                <button
                                    class="gradient-left"
                                    on:click={() => uploadFile()}
                                    disabled={uploading}
                                >
                                    Upload
                                </button>
                                {#if !uploading}
                                    {message}
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-grouped">
                    <div class="control">
                        <button
                            class="button gradient-left"
                            on:click={createNewContent}>Anlegen</button
                        >
                    </div>
                    <div class="control">
                        <button
                            class="button gradient-left"
                            on:click={() => (newContentModalOpen = false)}
                            >Abbrechen</button
                        >
                    </div>
                </div>
            </div>
        </div>
        <button
            class="modal-close is-large"
            aria-label="close"
            on:click={() => (newContentModalOpen = false)}
        />
    </div>
{/if}

<style>
    .sticky {
        position: sticky;
        top: 0rem;
    }

    .column {
        text-align: center;
    }

    .card {
        border-radius: 100px;
        padding: 1rem;
        padding-bottom: 0;
    }

    .greenish {
        background-color: #14acab;
        border-radius: 40px;
        color: white;
        height: 50px;
        margin: 0 11px;
        padding: 13px;
    }

    .greenish-plus {
        background-color: #14acab;
        border-radius: 40px;
        color: white;
        height: 50px;
        width: 50px;
        margin: auto;
        padding: 13px;
        font-size: 2rem;
        font-weight: 600;
        line-height: 25px;
    }

    .greenish-plus:hover {
        cursor: pointer;
    }
</style>
